import type React from 'react';
import { RoundedButton } from '../../../form/Button';
import Table from '../../../table/Table';
import type { UseOrderAndPaginationControlReturn } from '../../../table/hooks';
import type { ProjectOverviewRow } from '../types';
import { OVERVIEW_GRID_COLUMN_WIDTHS } from '../table/overviewGrid';
import { getProjectRowKey } from '../hooks/useExpandedProjectRows';
import { OverviewSectionCard } from './OverviewSectionCard';

interface OverviewCatalogSectionProps {
    title: string;
    projectRows: ProjectOverviewRow[];
    columns: React.ComponentProps<typeof Table<ProjectOverviewRow>>['columns'];
    pageUpdating: boolean;
    orderAndPaginationControl: UseOrderAndPaginationControlReturn;
    renderExpandedRows: (projectRow: ProjectOverviewRow) => React.ReactNode;
    onRowClick: (
        project: ProjectOverviewRow,
        event?: React.MouseEvent<HTMLTableRowElement>
    ) => void;
}

export function OverviewCatalogSection({
    title,
    projectRows,
    columns,
    pageUpdating,
    orderAndPaginationControl,
    renderExpandedRows,
    onRowClick,
}: OverviewCatalogSectionProps): React.ReactElement {
    return (
        <OverviewSectionCard
            title={title}
            action={
                <RoundedButton href="/measuring_point/download/csv">
                    {gettext('DOWNLOAD_AS_CSV')}
                </RoundedButton>
            }
        >
            <Table
                data={projectRows}
                columns={columns}
                loading={pageUpdating}
                orderAndPaginationControl={orderAndPaginationControl}
                renderExpandedRows={renderExpandedRows}
                columnWidths={OVERVIEW_GRID_COLUMN_WIDTHS}
                getRowKey={getProjectRowKey}
                showBorder={false}
                showDivider={false}
                wrapperClasses="overflow-visible bg-white"
                headerRowClasses="bg-gray-50"
                headerCellClasses="px-4 py-3 text-left text-xs uppercase tracking-wide text-gray-500"
                rowClasses="border-b border-gray-200 text-sm last:border-b-0 hover:bg-gray-50 transition-colors"
                rowCellClasses="px-4 py-3 align-middle text-sm text-gray-700 relative"
                onRowClick={onRowClick}
            />
        </OverviewSectionCard>
    );
}
